module.exports = __webpack_public_path__ + "static/media/ic_risk_analyse.26e836a3.svg";